module.exports = __webpack_public_path__ + "img/VE.7cb971d4.png";